import { CommonModule } from '@angular/common';
import { Component, effect, inject, model, untracked } from '@angular/core';
import { DialogComponent } from '@app/components/dialog';
import { AdminEligibilityFileImportService } from '@app/services/admin-eligibility-file-import/admin-eligibility-file-import.service';
import { EligibilityFileComponent } from '../eligibility-file/eligibility-file.component';
import { InviteUsersComponent } from '../invite-users/invite-users.component';

type View = 'file' | 'input';

@Component({
  standalone: true,
  selector: 'app-add-users-dialog',
  templateUrl: './add-users.component.html',
  styleUrl: './add-users.component.css',
  imports: [
    CommonModule,
    EligibilityFileComponent,
    InviteUsersComponent,
    DialogComponent,
  ],
})
export class AddUsersDialogComponent {
  eligibilityFilesImportService = inject(AdminEligibilityFileImportService);
  isOpen = model(false);
  view = model<View>('input');

  handleViewChange(view: View) {
    this.eligibilityFilesImportService.clearProcessedFiles();
    this.view.set(view);
  }

  constructor() {
    effect(() => {
      const currentlyOpen = this.isOpen();
      untracked(() => {
        if (!currentlyOpen) {
          this.eligibilityFilesImportService.clearProcessedFiles();
          this.view.set('input');
        }
      });
    });
  }
}
